import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

import { useCompany } from '../../contexts/CompanyContext';

interface HeaderProps {
  title?: string;
  showUserMenu?: boolean;
  onUserMenuClick?: () => void;
}

const Header = ({ title, showUserMenu = true }: HeaderProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const { currentCompany, switchCompany } = useCompany();

  const handleCompanyChange = (companyId: string) => {
    switchCompany(companyId);
    // Optionally reload current page data for new company
    window.location.reload();
  };

  const handleLogout = () => {
    // Clear any stored authentication data
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    sessionStorage.clear();
    
    // Navigate to login screen
    navigate('/login-screen');
    
    // Close dropdown
    setShowDropdown(false);
  };

  const handleProfile = () => {
    navigate('/user-profile-and-system-settings');
    setShowDropdown(false);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-4">
          {title && (
            <h1 className="text-xl font-semibold text-foreground">{title}</h1>
          )}
        </div>

        <div className="flex items-center gap-4">
          <button
            className="p-2 hover:bg-muted rounded-md transition-colors duration-150 relative"
            aria-label="Notificações"
          >
            <Icon name="Bell" size={20} color="var(--color-muted-foreground)" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-error rounded-full" />
          </button>

          <button
            className="p-2 hover:bg-muted rounded-md transition-colors duration-150"
            aria-label="Ajuda"
          >
            <Icon name="HelpCircle" size={20} color="var(--color-muted-foreground)" />
          </button>

          {showUserMenu && (
            <div className="relative">
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="flex items-center gap-2 px-3 py-2 hover:bg-muted rounded-md transition-colors duration-150"
                aria-label="Menu do usuário"
              >
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
                  <Icon name="User" size={16} color="var(--color-primary-foreground)" />
                </div>
                <Icon name="ChevronDown" size={16} color="var(--color-muted-foreground)" />
              </button>

              {showDropdown && (
                <>
                  <div
                    className="fixed inset-0 z-10"
                    onClick={() => setShowDropdown(false)}
                  />
                  <div className="absolute right-0 mt-2 w-56 bg-card rounded-md shadow-lg border border-border z-20">
                    <div className="p-3 border-b border-border">
                      <p className="text-sm font-medium text-foreground">Usuário do Sistema</p>
                      <p className="text-xs text-muted-foreground">usuario@empresa.com.br</p>
                    </div>
                    <div className="py-1">
                      <button
                        onClick={handleProfile}
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                      >
                        <Icon name="User" size={16} color="var(--color-muted-foreground)" />
                        <span>Perfil e Configurações</span>
                      </button>
                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-destructive hover:bg-destructive/10 transition-colors"
                      >
                        <Icon name="LogOut" size={16} color="var(--color-destructive)" />
                        <span>Sair do Sistema</span>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;